import { isAfter as n, isBefore as t, isEqual as e } from "date-fns";
import { enToFaDigits as r, faToEnDigits as u } from "jb-core";
const i = "    /  /  ", l = "YYYY/MM/DD", o = /^(?<year>[\u06F0-\u06F90-9,\s]{4})\/(?<month>[\u06F0-\u06F90-9,\s]{2})\/(?<day>[\u06F0-\u06F90-9,\s]{2})$/g;
let a = function(n) {
	return n.jalali = "JALALI", n.gregorian = "GREGORIAN", n;
}({});
function c(n) {
	return [
		1,
		5,
		9,
		13,
		17,
		22,
		26,
		30
	].includes(n % 33);
}
function s() {
	return {
		gregorian: {
			year: null,
			month: null,
			day: null
		},
		jalali: {
			year: null,
			month: null,
			day: null
		},
		timeStamp: null,
		time: {
			hour: null,
			minute: null,
			second: null,
			millisecond: null
		}
	};
}
function f(n) {
	return n.substring(5, 7);
}
function d(n) {
	return n.substring(0, 4);
}
function g(n) {
	return n.substring(8, 10);
}
function m(n) {
	return n < 5 ? "YEAR" : n < 8 ? "MONTH" : n < 11 ? "DAY" : null;
}
function h(n, t, e, r, u) {
	let i = !1;
	if (8 == e && t > 3 && (u("0", e), e++), 9 == e && t > 1 && "3" == r[8] && (i = !0), 9 == e && 0 == t && "0" == r[8] && (i = !0), 8 == e && 0 == t && "0" == r[9] && (i = !0), "JALALI" == n && !i) {
		const n = f(r), l = Number(n);
		if (9 == e && "3" == r[8] && t > 0 && l > 6 && (i = !0), 8 == e && 3 == t) {
			if (12 == l) {
				const n = Number(d(r));
				!Number.isNaN(n) && c(n) || (i = !0);
			}
			r[9] > "0" && (2 == n.length && parseInt(r) > 6 && u("0", 9), 2 == n.length && l < 7 && r[9] > "1" && u("1", 9));
		}
	}
	return {
		isIgnoreChar: i,
		caretPos: e
	};
}
function p(n, t, e) {
	let r = !1;
	return 5 == e && 1 == t && n[6] > "2" && (r = !0), 6 == e && t > 2 && "1" == n[5] && (r = !0), 6 == e && 0 == t && "0" == n[5] && (r = !0), 5 == e && 0 == t && "0" == n[4] && (r = !0), {
		isIgnoreChar: r,
		caretPos: e
	};
}
function F(t, r) {
	return n(t, r) || e(t, r);
}
function y(n, r) {
	return t(n, r) || e(n, r);
}
function b(n) {
	return /[\u06F0-\u06F90-9/]/g.test(n);
}
function I(n) {
	return u(n).replace(/[^\u06F0-\u06F90-9/]/g, "");
}
function N(n, t, e, u) {
	if (4 != t && 7 != t || (n = "/"), t > 9 || t < 0) return e;
	const i = e.split("");
	return u && (n = r(n)), i[t] = n, i.join("");
}
function C(n) {
	const { showPersianNumber: t, dateInputType: e, selection: r, event: { data: u, inputType: i } } = n, l = r.start;
	let o = l, a = n.value;
	return u && I(n.event.data || "").split("").forEach((n, t) => {
		let r = l + t;
		if (!b(n)) return;
		4 != r && 7 != r || ("/" == n && s(r + 1), r++);
		let u = !1;
		if ("/" == n) return;
		const i = Number(n);
		5 == r && i > 1 && (c("0", r), r++);
		const o = p(a, i, r);
		r = o.caretPos;
		const f = h(e, i, r, a, c);
		r = f.caretPos, u = u || f.isIgnoreChar || o.isIgnoreChar, u || (c(n, r), s(r + 1));
	}), "deleteContentBackward" != i && "deleteContentForward" != i && "delete" != i && "deleteByCut" != i && "deleteByDrag" != i || function(n, t, e, r, u) {
		let i = 0;
		"deleteContentBackward" == n && (i = t !== e ? 0 : -1);
		for (let n = t; n <= e; n++) r(" ", n + i);
		u(t + i);
	}(i, r.start, r.end, c, s), {
		value: a,
		selectionStart: o,
		selectionEnd: o
	};
	function c(n, e) {
		a = N(n, e, a, t);
	}
	function s(n) {
		o = n;
	}
}
function A(n) {
	const t = n.selectionStart;
	if (t) {
		const e = d(n.inputValue).trim().length, r = f(n.inputValue).trim().length, u = g(n.inputValue).trim().length;
		if (e < t && (t <= 4 || 0 == r && 0 == u)) return e;
		if (t > 4 && (t <= 7 && r + 5 < t || 0 == u && r < 2)) return r + 5;
		if (u + 8 < t && t > 7 && t <= 10) return u + 8;
	}
	return null;
}
export { a as InputTypes, y as checkMaxValidation, F as checkMinValidation, i as emptyInputValueString, g as getDay, s as getEmptyValueObject, A as getFixedCaretPos, f as getMonth, m as getSelectionPart, d as getYear, C as handleBeforeInput, h as handleDayBeforeInput, p as handleMonthBeforeInput, l as inputFormat, o as inputRegex, c as isLeapYearJalali, b as isValidChar, N as replaceChar, I as standardString };

//# sourceMappingURL=index.js.map